import { render, staticRenderFns } from "./home_menu.vue?vue&type=template&id=391a6846&scoped=true"
import script from "./home_menu.vue?vue&type=script&lang=js"
export * from "./home_menu.vue?vue&type=script&lang=js"
import style0 from "./home_menu.vue?vue&type=style&index=0&id=391a6846&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a6846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391a6846')) {
      api.createRecord('391a6846', component.options)
    } else {
      api.reload('391a6846', component.options)
    }
    module.hot.accept("./home_menu.vue?vue&type=template&id=391a6846&scoped=true", function () {
      api.rerender('391a6846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_menu.vue"
export default component.exports